/**
 * Minimal footer — quiet, monochrome, single row.
 */
import { Link } from "react-router-dom";

// CD Bible Study community — Telegram invite (AI-6749).
const COMMUNITY_TELEGRAM_URL = "https://t.me/+dlCZeDYzd9gyYTNh";

export function MinimalFooter() {
  return (
    <footer className="border-t border-neutral-200 bg-[#FAFAF7] px-6 py-12 md:px-12">
      <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-neutral-900">
          Jesus Entered the Chat
        </p>
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-neutral-500">
          <a href="#features" className="transition hover:text-neutral-900">
            Features
          </a>
          <Link to="/gallery" className="transition hover:text-neutral-900">
            Gallery
          </Link>
          <Link to="/waitlist" className="transition hover:text-neutral-900">
            Waitlist
          </Link>
          <Link to="/download" className="transition hover:text-neutral-900">
            Install
          </Link>
          <Link to="/pilot" className="transition hover:text-neutral-900">
            Partner pilot
          </Link>
          <Link to="/contact" className="transition hover:text-neutral-900">
            Contact
          </Link>
          <a
            href={COMMUNITY_TELEGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="transition hover:text-neutral-900"
          >
            Community
          </a>
          <Link to="/sign-in" className="transition hover:text-neutral-900">
            Sign in
          </Link>
        </nav>
        <p className="text-xs text-neutral-400">
          © {new Date().getFullYear()} Jesus Entered the Chat · A companion, not a replacement for your pastor.
        </p>
      </div>
    </footer>
  );
}
